import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { useModalForms } from '../modalFormsContext'
import { Container, LabelContent } from './style'

export function NavigatorButtonsToShowContent() {
    const { 
            setChangeVisibleContent, 
            changeVisibleContent, 
            formChangeVisibleContentFromNavigatorButtons,
            setAlertButtonToClickHim 
    } = useModalForms()

    const { informationsToShowInPage } = useAdministrativeContext()

    const ListOfNavigationButtons = 
        informationsToShowInPage === 'coupons' ? ['Dados', 'Regras', 'Validade'] : []

    return(
        <Container>
            {
                ListOfNavigationButtons.map((navigator, index) => (
                    <LabelContent 
                        key={index}
                        isActive={changeVisibleContent === index}
                        onClick={() =>{   
                            if(index <= formChangeVisibleContentFromNavigatorButtons){
                                setChangeVisibleContent(index)
                            }else{
                                setAlertButtonToClickHim({breathButton: true, index: index})
                            }      
                        }}
                    >
                        <p>{navigator}</p>
                        <div />
                    </LabelContent>
                ))
            }
        </Container>
    )
}